import axiosInstance from './axiosService';

// FAQ Mutations
export const fetchFaqData = async () => {
    const response = await axiosInstance.get('/admin/faqs/');
    return response.data;
};

export const createFaq = async (data: any) => {
    const response = await axiosInstance.post('/admin/faqs/', data);
    return response.data;
};

export const updateFaq = async (id: number, data: any) => {
    const response = await axiosInstance.put(`/admin/faqs/${id}/`, data);
    return response.data;
};

export const deleteFaq = async (id: number) => {
    const response = await axiosInstance.delete(`/admin/faqs/${id}/`);
    return response.data;
};

// Legal Content Mutations
export const fetchLegalContent = async () => {
    const response = await axiosInstance.get('/admin/legal-content/');
    return response.data;
}

export const createLegalContent = async (data: any) => {
    const response = await axiosInstance.post('/admin/legal-content/', data);
    return response.data;
};

export const updateLegalContent = async (id: number, data: any) => {
    const response = await axiosInstance.put(`/admin/legal-content/${id}/`, data);
    return response.data;
};

export const deleteLegalContent = async (id: number) => {
    const response = await axiosInstance.delete(`/admin/legal-content/${id}/`);
    return response.data;
};

// Document Resource Mutations
export const fetchDocumentResources = async () => {
    const response = await axiosInstance.get('/admin/documents/?doc_type=resource');
    return response.data;
};

export const createDocumentResource = async (data: any) => {
    const response = await axiosInstance.post('/admin/documents/?doc_type=resource', data, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return response.data;
};

export const updateDocumentResource = async (id: number, data: any) => {
    const response = await axiosInstance.patch(`/admin/documents/?doc_type=resource&id=${id}`, data, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return response.data;
};

export const deleteDocumentResource = async (id: number) => {
    const response = await axiosInstance.delete(`/admin/documents/?doc_type=resource&id=${id}`);
    return response.data;
};

// Form Resource Mutations

export const fetchFormResources = async () => {
    const response = await axiosInstance.get('/admin/documents/?doc_type=form');
    return response.data;
};

export const createFormResource = async (data: any) => {
    const response = await axiosInstance.post('/admin/documents/?doc_type=form', data, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return response.data;
};

export const updateFormResource = async (id: number, data: any) => {
    const response = await axiosInstance.patch(`/admin/documents/?doc_type=form&id=${id}`, data, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return response.data;
};

export const deleteFormResource = async (id: number) => {
    const response = await axiosInstance.delete(`/admin/documents/?doc_type=form&id=${id}`);
    return response.data;
};

// BAA Document Mutations
export const fetchBAADocuments = async () => {
    const response = await axiosInstance.get('/admin/documents/?doc_type=baa');
    return response.data;
};

export const createBAADocument = async (data: any) => {
    const response = await axiosInstance.post('/admin/documents/?doc_type=baa', data, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return response.data;
};

export const updateBAADocument = async (id: number, data: any) => {
    const response = await axiosInstance.patch(`/admin/documents/?doc_type=baa&id=${id}`, data, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return response.data;
};

export const deleteBAADocument = async (id: number) => {
    const response = await axiosInstance.delete(`/admin/documents/?doc_type=baa&id=${id}`);
    return response.data;
};

export const fetchPublicBAA = async () => {
    const response = await axiosInstance.get(`/admin/public/baa/`);
    return response.data;
};

export const fetchPublicLegalContent = async (type: string = 'TERMS') => {
    const response = await axiosInstance.get(`/admin/public/legal-content/?type=${type}`);
    return response.data;
};

// Medication Lookups Mutations
export const createMedication = async (data: any) => {
    const response = await axiosInstance.post('/admin/medications/', data);
    return response.data;
};

export const fetchMedications = async (params?: { type?: string; page?: number; page_size?: number; search?: string }) => {
    const response = await axiosInstance.get('/admin/medications/', { params });
    return response.data;
};

export const updateMedication = async (id: number, data: any) => {
    const response = await axiosInstance.patch(`/admin/medications/${id}/`, data);
    return response.data;
};

export const deleteMedication = async (id: number) => {
    const response = await axiosInstance.delete(`/admin/medications/${id}/`);
    return response.data;
};

// Surgery Lookups Mutations

export const createSurgery = async (data: any) => {
    const response = await axiosInstance.post('/admin/surgeries/', data);
    return response.data;
};

export const fetchSurgeries = async (params?: { type?: string; page?: number; page_size?: number; search?: string }) => {
    const response = await axiosInstance.get('/admin/surgeries/', { params });
    return response.data;
};

export const updateSurgery = async (id: number, data: any) => {
    const response = await axiosInstance.patch(`/admin/surgeries/${id}/`, data);
    return response.data;
};

export const deleteSurgery = async (id: number) => {
    const response = await axiosInstance.delete(`/admin/surgeries/${id}/`);
    return response.data;
};


// Questionnaire Mutations 
export const fetchQuestionnaire = async () => {
    const response = await axiosInstance.get('/admin/questions/');
    return response.data;
};

export const createQuestionnaireSection = async (data: any) => {
    const response = await axiosInstance.post('/admin/questions/', data);
    return response.data;
};

export const updateQuestionnaireSection = async (id: number, data: any) => {
    const response = await axiosInstance.patch(`/admin/questions/${id}/`, data);
    return response.data;
};

export const deleteQuestionnaireSection = async (id: number) => {
    const response = await axiosInstance.delete(`/admin/questions/${id}/`);
    return response.data;
};

// Question Mutations
export const createQuestion = async (data: any) => {
    const response = await axiosInstance.post('/admin/questions/', data);
    return response.data;
};

export const updateQuestion = async (id: number, data: any) => {
    const response = await axiosInstance.patch(`/admin/questions/${id}/`, data);
    return response.data;
};

export const deleteQuestion = async (id: number) => {
    const response = await axiosInstance.delete(`/admin/questions/${id}/`);
    return response.data;
};

// Clinic Mutations
export const fetchClinics = async (params?: { page?: number; page_size?: number; search?: string }) => {
    const response = await axiosInstance.get('/admin/clinics/', { params });
    return response.data;
};

export const fetchClinicById = async (id: string | number) => {
    const response = await axiosInstance.get(`/admin/clinics/${id}/`);
    return response.data;
};

export const updateClinic = async (id: string | number, data: any) => {
    const response = await axiosInstance.put(`/admin/clinics/${id}/`, data);
    return response.data;
};

export const deleteClinic = async (id: string | number) => {
    const response = await axiosInstance.delete(`/admin/clinics/${id}/`);
    return response.data;
};

// User Mutations
export const fetchAdminUsers = async (params?: { page?: number; page_size?: number; search?: string }) => {
    const response = await axiosInstance.get('/admin/users/', { params });
    return response.data;
};

export const updateAdminUser = async (id: string | number, data: { is_disabled: boolean }) => {
    const response = await axiosInstance.put(`/admin/users/${id}/`, data);
    return response.data;
};

export const resetAdminUserPassword = async (id: string | number, data: { password: string }) => {
    const response = await axiosInstance.post(`/admin/users/${id}/reset_password/`, data);
    return response.data;
};
export const fetchAdminTransactions = async (params?: { page?: number; page_size?: number; search?: string }) => {
    const response = await axiosInstance.get('/admin/transactions/', { params });
    return response.data;
};

export const fetchAdminDashboardStats = async () => {
    const response = await axiosInstance.get('/admin/dashboard/');
    return response.data;
};

export const postDownloadInvoice = async (invoiceId: string) => {
    const response = await axiosInstance.post('/admin/transactions/download_invoice/',
        { invoice_id: invoiceId }
    );
    return response.data;
};

// Salesperson and Campaign Mutations
export const fetchSalesPersons = async () => {
    const response = await axiosInstance.get('/admin/salespersons/');
    return response.data;
};

export const createSalesPerson = async (data: any) => {
    const response = await axiosInstance.post('/admin/salespersons/', data);
    return response.data;
};

export const updateSalesPerson = async (id: number | string, data: any) => {
    const response = await axiosInstance.patch(`/admin/salespersons/${id}/`, data);
    return response.data;
};

export const deleteSalesPerson = async (id: number | string) => {
    const response = await axiosInstance.delete(`/admin/salespersons/${id}/`);
    return response.data;
};

export const fetchCampaignCodes = async () => {
    const response = await axiosInstance.get('/admin/campaign-codes/');
    return response.data;
};

export const createCampaignCode = async (data: any) => {
    const response = await axiosInstance.post('/admin/campaign-codes/', data);
    return response.data;
};

export const updateCampaignCode = async (id: number | string, data: any) => {
    const response = await axiosInstance.patch(`/admin/campaign-codes/${id}/`, data);
    return response.data;
};

export const deleteCampaignCode = async (id: number | string) => {
    const response = await axiosInstance.delete(`/admin/campaign-codes/${id}/`);
    return response.data;
};

export const fetchCampaignInvitedClinics = async (id: number | string) => {
    const response = await axiosInstance.get(`/admin/campaign-codes/${id}/invited_clinics/`);
    return response.data;
};

// Release Notes Mutations
export const fetchReleaseNotes = async (params?: { q?: string; all?: boolean }) => {
    const response = await axiosInstance.get('/admin/release-notes/', { params });
    return response.data;
};

export const createReleaseNote = async (data: { version: string; title: string; description: string; is_published?: boolean }) => {
    const response = await axiosInstance.post('/admin/release-notes/', data);
    return response.data;
};

export const updateReleaseNote = async (id: number, data: { version?: string; title?: string; description?: string; is_published?: boolean }) => {
    const response = await axiosInstance.put(`/admin/release-notes/${id}/`, data);
    return response.data;
};

export const deleteReleaseNote = async (id: number) => {
    const response = await axiosInstance.delete(`/admin/release-notes/${id}/`);
    return response.data;
};

